import axios from "axios";
require('dotenv').config()

const apifiscal = axios.create({
  baseURL: process.env.VUE_APP_URL_FISCAL,
});

export default apifiscal;
